import React from 'react';
export function TopBar() {
  return <div className="bg-brand-sand text-brand-text py-2 px-4 text-center text-xs sm:text-sm font-semibold tracking-wide" data-id="element-197">
      <p data-id="element-198">
        Producto 100% digital · Descarga inmediata · Creá y vendé desde casa
      </p>
    </div>;
}